<script>
	import { Router, Route } from "svelte-routing";
	import MainEvAccManagement from "./Manage/MainEvAccManagement.svelte";
	import CreateEvAccForm from "./CreateEvAccForm.svelte";
	import EditEvAcc from "./EditEvAcc.svelte";
</script>

<Router url="/">
	<Route path="/" component={MainEvAccManagement} />
	<Route path="/create" component={CreateEvAccForm} />
	<Route path="/edit" component={EditEvAcc} />
</Router>
